// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2BWu1","label":"Completed_label__J9FRb"};